import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'trqk-logo';

const originalDimensions = {
    width: 623.97,
    height: 299.969,
};

export const IconTrqkLogo = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'highlight-darkblue';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, opacity = 0.05 } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Trqk Logo</title>
            <path
                d="M398.94 148.913h-.56M164.95.979H-15.04v33.158h72.08v201.794h35.82V34.137h72.09V.979zm378.43 127.84l65.88-66.6h-47.08l-68.45 69.3v-147.53h-35.82v251.289h35.82v-56.129l19.46-19.806c41.54 1.242 74.96 34.669 74.96 75.684h35.82c0-50.065-34.02-92.466-80.59-106.208zm-379.75 11.816c0-28.617 23.75-51.9 52.94-51.9a53.678 53.678 0 0118.06 3.093l12.23-33a90.094 90.094 0 00-30.29-5.2c-48.94 0-88.76 39.032-88.76 87v95.3h35.82v-95.3zm173.63-87.827c-52.35 0-94.95 41.748-94.95 93.062s42.58 93.062 94.92 93.062a95.9 95.9 0 0039.08-8.294v-41.43a59.408 59.408 0 01-39.08 14.615c-32.59 0-59.1-26-59.1-57.953s26.53-57.954 59.13-57.954 59.13 26 59.13 57.954v154.109h35.82V145.87c0-51.314-42.6-93.062-94.95-93.062z"
                fill={fill}
                fillRule="evenodd"
                opacity={opacity}
            />
        </svg>
    );
};
